import React, {Component} from "react";

import { IS_VALID }       from "utils";

import View               from "./View";
import Update             from "./Update";

export default class FormContainer extends Component {
  render () {
    let {
      PendingNotification
    } = this.props;

    let {
      formType,
      selectedData
    } = PendingNotification;

    let updateProps = {
      reduxStateName: "PendingNotification",
      ...this.props
    };

    switch (formType.toUpperCase()) {
      case "VIEW":
        return <View {...this.props}/>;
        break;
      case "UPDATE":
        return <Update {...updateProps}/>
      case "DELETE":
        return (
          <p>
            Are you sure you want to delete&nbsp;
            {IS_VALID(selectedData) && IS_VALID(selectedData.get("subject")) ? (
              <span style={{ color: "red" }}>{selectedData.get("subject")}</span>
            ) : (
              "this data"
            )}
            ?
          </p>
        );
      default:
        return ("");
    }
  }

  componentWillUnmount () {
    let {
      actions
    } = this.props;

    actions.setValue(
      {
        selectedData: null,
        formType: "",
        formId: "",
        formTitle: "",

        sendMode: {
      		value: "TEST",
      		label: "TEST"
      	},
        userType: {
      		value: 'MEMBER',
      		label: 'MEMBER'
      	},
        cardType: [],
        ageBracket: [35, 45],
        gender: null,
        device: {
      		value: 'ALL',
      		label: 'ALL'
      	},
        screen: null,
        browser: null,
        specificUser: [],
        blacklistedUser: [],

        subject: "",
        url: "",
        message: "",
        isSendNow: true,
      	scheduleDateTimeNotif: ""
      }
    );
  }
}



// WEBPACK FOOTER //
// ./components/PendingNotification/FormContainer/index.js